import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Filter } from "../../models/filter.model";
import { OrganisationInvite } from "../../models/organisation-invite.model";
import { Organisation } from "../../models/organisation.model";
import { User } from "../../models/user.model";
import { OrganisationUserDataProvider } from "../../data-provider/organisation-user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { OrganisationInviteDataProvider } from "../../data-provider/organisation-invite.dp";

let OrganisationInviteListComponent = {
    selector: "vcOrganisationInviteList",
    templateUrl:
        "/angular/components/organisation-invite/organisation-invite-list.component.html",
    bindings: {
        filter: "=?",
    },
    controller: class OrganisationInviteListController {
        // * bindings for typescript compiler *
        public filter?: Filter;
        // ************************************

        private $scope: any;
        public organisationUserDataProvider: OrganisationUserDataProvider;
        private $window: any;
        private campaignDataProvider: CampaignDataProvider;
        private dataProvider: OrganisationInviteDataProvider;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        public invites: Array<any>;
        public activeOrganisation: Organisation;

        constructor(
            $scope: any,
            $window: any,
            OrganisationUserDataProvider: OrganisationUserDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            OrganisationInviteDataProvider: OrganisationInviteDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils
        ) {
            this.$scope = $scope;
            this.organisationUserDataProvider = OrganisationUserDataProvider;
            this.$window = $window;
            this.campaignDataProvider = CampaignDataProvider;
            this.dataProvider = OrganisationInviteDataProvider;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;

            this.campaignDataProvider
                .getOrganisations()
                .then((organisation) => {
                    this.activeOrganisation = organisation;
                    if (organisation.oid) {
                        this.dataProvider
                            .getAllInvites(this.activeOrganisation.oid)
                            .then((invites: any) => {
                                this.invites = invites;
                            });
                    }
                });
        }

        updateUser(user: User, ev: any): void {
            this.dialog
                .show({
                    component: "vc-leader-user",
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    size: "large",
                    locals: {
                        organisation: this.activeOrganisation,
                        selectedUser: user,
                    },
                })
                .then((data: object) => _.merge(user, data));
        }

        resendInvite(invite: OrganisationInvite): void {
            this.dataProvider.resend(invite).then(
                () => {
                    invite.deliverytimestamp = null;
                    invite.deliverystatus = "Sent";
                    this.toast.success(
                        "Invite resent to " + invite.organisationinviteemail
                    );
                },
                () => this.toast.error()
            );
        }

        deleteInvite(invite: OrganisationInvite, $event: any): void {
            this.dialog
                .delete({
                    targetEvent: $event,
                    locals: {
                        bodyText: `It will be permanently deleted`,
                        title: `Delete Invite?`,
                    },
                })
                .then(() => {
                    this.dataProvider.deleteInvite(invite).then(() => {
                        this.toast.success("Invite Deleted");
                    });
                });
        }
    },
};

angular
    .module("organisationInvite")
    .component(
        OrganisationInviteListComponent.selector,
        OrganisationInviteListComponent
    );
